import React, {Component, ReactNode} from 'react';
import I18n from 'app/i18n';
import {IncubatorCreateLineController} from 'app/controllers/IncubatorCreateLineController';
import {inject, observer} from 'mobx-react';
import {ParamsInterface} from 'app/utils/Get';
import {BLUE} from 'app/lines/line_helpers';
import {isDesktop} from 'app/utils';
import IncubatorLineTimer from 'app/components/pages/incubator/line/IncubatorLineTimer';
import IncubatorOpenLineOrAddTime from 'app/components/pages/incubator/line/IncubatorOpenLineOrAddTime';
import {isClosedLine} from 'utils/line_helpers';

interface Props {
    controller: IncubatorCreateLineController
}

@inject('controller')
@observer
export default class IncubatorLineControlButtons extends Component {
    get controller(): IncubatorCreateLineController {
        const props = this.props as Props;
        return props.controller;
    }

    state = {
        closeButtonDisabled: false,
        plus2ButtonDisabled: false,
        plus5ButtonDisabled: false
    };

    handleKeyPress = (e: KeyboardEvent): void => {
        if (e.metaKey || e.ctrlKey || document.activeElement.className === 'chat__input-text js-chat-input') {
            return;
        }
        this.handleInputs(e.key);
        this.handleFocus(e.key);
    };

    handleInputs(value: string): void {
        if (value === 'T' || value === 't') {
            this.disableButton(
                () => this.addTime({time: 2}),
                'plus2ButtonDisabled'
            );
        }
        if (value === 'F' || value === 'f') {
            this.disableButton(
                () => this.addTime({time: 5}),
                'plus5ButtonDisabled'
            );
        }
        if (value === 'C' || value === 'c') {
            this.disableButton(
                () => this.controller.close({id: this.controller.incubatorGame.id}),
                'closeButtonDisabled'
            );
        }
        if (value === 'A' || value === 'a') {
            this.disableButton(
                () => this.controller.acceptAndClose({id: this.controller.incubatorGame.id}),
                'closeButtonDisabled'
            );
        }
    }

    handleFocus(value:string): void {
        if (value === 'ArrowRight') {
            const rightInput = document.getElementById('line[coef_2]');

            if (rightInput) {
                rightInput.focus();
            }
        }
        if (value === 'ArrowLeft') {
            const leftInput = document.getElementById('line[coef_1]');

            if (leftInput) {
                leftInput.focus();
            }
        }
    }

    componentDidMount(): void {
        document.addEventListener('keydown', this.handleKeyPress);
    }

    componentWillUnmount(): void {
        document.removeEventListener('keydown', this.handleKeyPress);
    }

    addTime = (params: ParamsInterface): Promise<Response> => this
        .controller.addTime({...params, id: this.controller.incubatorGame.id});

    handleClose = (e: React.MouseEvent<HTMLButtonElement>): void => {
        e.preventDefault();

        this.disableButton(
            () => this.controller.close({id: this.controller.incubatorGame.id}),
            'closeButtonDisabled'
        );
    };

    handleAcceptAndClose = (e: React.MouseEvent<HTMLButtonElement>): void => {
        e.preventDefault();

        this.disableButton(
            () => this.controller.acceptAndClose({id: this.controller.incubatorGame.id}),
            'closeButtonDisabled'
        );
    };

    disableButton = (fun: () => Promise<unknown>, state: string): void => {
        if (this.state[state]) {
            return;
        }
        this.setState({[state]: true});
        fun().finally(() => {
            this.setState({[state]: false});
        });
    };

    render(): ReactNode {
        const {color, date, status} = this.controller.incubatorGame.lineStore.collection;
        const lineClosed = color !== BLUE;
        const classDisabled = lineClosed ? ' button-adaptive_disable' : '';
        const {closeButtonDisabled} = this.state;

        return <>
            <div className="incubator-line-controller">
                {isDesktop() && <div className="top-part">
                    <IncubatorLineTimer
                        lineClosed={lineClosed}
                        date={date}
                    />
                </div>}
                <div className="middle-part">
                    {isDesktop() && <div className="cell">
                        <IncubatorOpenLineOrAddTime />
                    </div>}
                    <div className="cell">
                        <button
                            onClick={this.handleClose}
                            type="button"
                            className={`button-adaptive button-adaptive_full-thin${classDisabled}`}
                            disabled={closeButtonDisabled}
                        >
                            {I18n.t(isDesktop() ? 'tooltip_incubator_close_line' : 'tooltip_incubator_close_line_mob')}
                        </button>
                    </div>
                    <div className="cell">
                        <button
                            onClick={this.handleAcceptAndClose}
                            type="button"
                            className={`button-adaptive button-adaptive_full-thin${classDisabled}`}
                            disabled={closeButtonDisabled}>
                            {I18n.t('incubator_accept_and_close')}
                        </button>
                    </div>
                    {!isDesktop() && <>
                        <div className="cell">
                            <button
                                type="submit"
                                className="button-adaptive button-adaptive_full-thin"
                                disabled={isClosedLine(status)}
                            >
                                {I18n.t('user.save')}
                            </button>
                        </div>
                    </>}
                </div>
            </div>
        </>;
    }
}
